import {
  ProjectEntity,
  Projects as ProjectsState,
  Project,
} from "./ProjectsContext";

enum ProjectsActionType {
  Add = "AddProject",
  Remove = "RemoveProject",
  SetProjects = "SetProjects",
  EditProject = "EditProject",
}

type AddProjectAction = {
  type: ProjectsActionType.Add;
  payload: {
    project: ProjectEntity;
  };
};

type RemoveProjectAction = {
  type: ProjectsActionType.Remove;
  payload: {
    projectId: string;
  };
};

type SetProjectsAction = {
  type: ProjectsActionType.SetProjects;
  payload: {
    projects: ProjectEntity[];
  };
};

type EditProjectAction = {
  type: ProjectsActionType.EditProject;
  payload: {
    id: string;
    project: Partial<Project>;
  };
};

type ProjectsAction =
  | AddProjectAction
  | RemoveProjectAction
  | SetProjectsAction
  | EditProjectAction;

export const addProject = (project: ProjectEntity): AddProjectAction => ({
  type: ProjectsActionType.Add,
  payload: { project },
});

export const removeProject = (projectId: string): RemoveProjectAction => ({
  type: ProjectsActionType.Remove,
  payload: { projectId },
});

export const setProjects = (projects: ProjectEntity[]): SetProjectsAction => ({
  type: ProjectsActionType.SetProjects,
  payload: { projects },
});

export const editProject = (
  id: string,
  project: Partial<Project>,
): EditProjectAction => ({
  type: ProjectsActionType.EditProject,
  payload: { id, project },
});

const projectsReducer = (
  state: ProjectsState,
  action: ProjectsAction,
): ProjectsState => {
  switch (action.type) {
    case ProjectsActionType.Add:
      const addedProject = action.payload.project;
      return {
        ...state,
        [addedProject.id]: addedProject,
      };
    case ProjectsActionType.Remove:
      const updatedState = { ...state };
      delete updatedState[action.payload.projectId];
      return updatedState;
    case ProjectsActionType.EditProject:
      const { id, project } = action.payload;
      return {
        ...state,
        [id]: {
          ...state[id],
          ...project,
        },
      };
    case ProjectsActionType.SetProjects:
      const projects = action.payload.projects;
      return projects.reduce(
        (acc, currentVal) => ({
          ...acc,
          [currentVal.id]: currentVal,
        }),
        {},
      );
    default:
      return state;
  }
};

export default projectsReducer;
